<div class="action-buttons">
  <button
    class="menu-button"
    (click)="deleteSubProject()"
    type="button"
    mat-button
    [disabled]="disableDelete"
  >
    Verwijder
  </button>
</div>
<create-view-base-project
  [project]="project"
  [subProject]="model"
  [client]="false"
  (save)="save.emit(model)"
  (projectContactChange)="saveContacts($event)"
></create-view-base-project>
